"use client";

import { Spinner } from "@/components/shadcn/spinner";
import { ReactNode } from "react";
import { useFilterPending } from "./filter-utils";

export default function SeriesGrid({ children }: { children: ReactNode }) {
    const isPending = useFilterPending();

    return (
        <div className="relative">
            <div
                className={
                    isPending ? "opacity-50 transition-opacity" : undefined
                }
            >
                {children}
            </div>
            {isPending && (
                <div className="absolute inset-0 flex items-start justify-center pt-20">
                    <Spinner />
                </div>
            )}
        </div>
    );
}
